 

import numberHumanizer from '@/helpers/numberHumanizer';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { decodeGetter } from '@/app/common/components/ag-grid/configs';
import { commonTooltips } from '@/app/common/tooltip/commonTooltips';
const menuTabs = ['columnsMenuTab', 'filterMenuTab', 'generalMenuTab'];

export const relatedKeywordsColumnConfig = [
  {
    searchable: true,
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterValueGetter: decodeGetter,
    field: 'related',
    type: 'string',
    title: 'کلمه کلیدی',
    flex: 1,
    minWidth: 150
  },
  {
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    field: 'search_volume_miztols',
    type: 'number',
    title: 'میزان جستجو (ماه)',
    width: 150,
    searchable: true,
    cellRenderer: params => (
      <>
        {!params.value ? (
          <HelpTooltip html={commonTooltips.searchVolume} />
        ) : (
          numberHumanizer(params.value)
        )}
      </>
    )
  },
  {
    menuTabs,
    field: 'importance',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    type: 'number',
    title: 'میزان اهمیت',
    width: 130,
    searchable: true
  },
  {
    searchable: true,
    field: 'length',
    type: 'number',
    menuTabs,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    title: 'طول',
    width: 90
  }
];
